/*global GetAppInfo, MOMReportEnum, TTTimeUnitEnum, MakeTextRequestURL, TTApplicationEnum */
/*eslint no-undef: "error"*/

import React, { Component } from 'react';
import { Redirect }         from 'react-router-dom';
import { connect }          from 'react-redux';
import moment               from 'moment';
import validator            from 'validator';
import { ConfigureReport }  from 'moovila-common';

import { showMessageBox } from '../../actions';

import reportConfig     from '../../constants/reportConfig';

const today = moment();
const defaultDates = {
  [TTTimeUnitEnum.TU_DAY]: today.subtract(1, 'month').format('YYYY-MM-DD'),
  [TTTimeUnitEnum.TU_WEEK]: today.add(1, 'month').subtract(3, 'months').format('YYYY-MM-DD'),
  [TTTimeUnitEnum.TU_MONTH]: today.add(3, 'months').subtract(1, 'year').format('YYYY-MM-DD'),
}

class ConfigureReportContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      redirect: false,
      report: null,
      intervalType: 0,
      startDate: '',
      endDate: '',
      userInput: false,
    };
    this.onChange     = this.onChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentWillMount() {
    const report = reportConfig.filter(report => report.code === this.props.reportCode)[0];
    if (!report) {
      this.setState({
        redirect: true,
      });
      return;
    }
    this.setState({
      report,
    })
    if (!report.isInterval) {
      // go ahead and launch report and redirect back to home
      this.openReport(report.code, false);
    }
  }

  onChange(e) {
    const name  = e.target.name;
    const value = e.target.value;
    this.setState({
      [name]: value,
    });
    if (name === 'intervalType' && !this.state.userInput) {
      this.setState({
        startDate: defaultDates[value],
        endDate: moment().format('YYYY-MM-DD'),
      });
    }
    if (name !== 'intervalType') {
      this.setState({
        userInput: true,
      });
    }
  }

  openReport(code, isInterval=true) {
    const reportID = MOMReportEnum[`R_${code}`];
    let   reportParms = {};

    if (isInterval) {
      reportParms = {
        ...reportParms,
        intervalType: Number(this.state.intervalType),
        startDate: moment(this.state.startDate).format(),
        endDate: moment(this.state.endDate).format(),
      };
    }

    const reqParams = {
      reportID,
      reportFormat: 'PDF',
      reportParms,
    }

    // const pReportParms = { enterpriseGUID: _moovilaSecurity.GetEnterpriseGUID() };

    if (!GetAppInfo(TTApplicationEnum.API)) {
      // race condition if you happen to load the report page directly
      setTimeout(() => this.openReport(...arguments), 100);
      return;
    }
    var strURL = MakeTextRequestURL("Reporting", "ExecuteReport", JSON.stringify(reqParams));
    window.open(strURL, "_blank");
    this.setState({ redirect: true });
  }

  validate() {
    let message = '';
    if (this.state.intervalType < 1) {
      message = 'Please select a repeat interval';
    } else if (!this.state.startDate.length) {
      message = 'Please provide a start date';
    } else if (!validator.isISO8601(moment(this.state.startDate).format())) {
      message = 'Please provide a valid start date';
    } else if (!this.state.endDate.length) {
      message = 'Please provide a end date';
    } else if (!validator.isISO8601(moment(this.state.endDate).format())) {
      message = 'Please provide a valid end date';
    } else if (!validator.isBefore(moment(this.state.startDate).format(), moment(this.state.endDate).format())) {
      message = 'Please make sure the start date is before the end date';
    } else if (!validator.isAfter(moment(this.state.startDate).format(), moment('2016-01-01').format())) {
      message = 'Please specify a start date after Jan. 1, 2016';
    } else if (Number(this.state.intervalType) === TTTimeUnitEnum.TU_DAY) {
      // day-specific validations
      if (validator.isBefore(moment(this.state.startDate).add(31, 'days').format(), moment(this.state.endDate).format())) {
        message = 'Daily reports are limited to 31 days';
      }
    } else if (Number(this.state.intervalType) === TTTimeUnitEnum.TU_WEEK) {
      // day-specific validations
      if (validator.isBefore(moment(this.state.startDate).add(180, 'days').format(), moment(this.state.endDate).format())) {
        message = 'Weekly reports are limited to 180 days';
      }
    } else if (Number(this.state.intervalType) === TTTimeUnitEnum.TU_MONTH) {
      // day-specific validations
      if (validator.isBefore(moment(this.state.startDate).add(36, 'months').format(), moment(this.state.endDate).format())) {
        message = 'Monthly reports are limited to 36 months';
      }
    }

    if (message) {
      this.props.showMessageBox({
        'title': 'Invalid Entry',
        message,
      });
      return false;
    }
    return true;
  }

  handleSubmit(e) {
    if (!this.validate()) {
      e.preventDefault();
      return;
    }
    this.openReport(this.state.report.code, true);
  }

  render() {
    if (this.state.redirect) {
      return <Redirect to="/home" />;
    }
    return (
      <ConfigureReport
        reportName={this.state.report.name}
        intervalType={this.state.intervalType}
        startDate={this.state.startDate}
        endDate={this.state.endDate}
        handleSubmit={this.handleSubmit}
        onChange={this.onChange}
        path={''}
      />
    );
  }
}

export default connect(s => s, {
  showMessageBox,
})(ConfigureReportContainer);



// WEBPACK FOOTER //
// ./src/containers/Reports/ConfigureReport.js